module.exports = __webpack_public_path__ + "assets/table.74891c4a.svg";